<template>
  <div>
    <atomic-link class="install-app-menu-item" @click="installApp" v-if="type === 'drawer'">
      <template v-if="!isDrawerCompact">
      <span class="install-app-menu-item__text">
        {{ getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.installApp') }}
      </span>
        <div class="install-app-menu-item__icons">
          <atomic-icon id="apple" />
          <atomic-icon id="android" />
        </div>
      </template>

      <template v-else>
        <atomic-icon id="install-app" />
      </template>
    </atomic-link>

    <div class="app-footer__install-app" @click="installApp" v-if="type === 'footer'">
      <div class="app-footer__install-app-text">
        {{ getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.installApp') }}
      </div>
      <div class="app-footer__install-app-icons">
        <atomic-icon id="apple" />
        <atomic-icon id="android" />
        <atomic-image src="/img/icons/chrome.svg" />
        <atomic-image src="/img/icons/safari.svg" />
      </div>
    </div>

    <bottom-sheet-install-app v-if="isMobile" ref="bsInstallApp" />
  </div>
</template>

<script setup lang="ts">
  import { UAParser } from 'ua-parser-js';
  import { ModalName } from '@skeleton/consts/modals';
  import type { IBottomSheetComponent } from '@skeleton/core/types';

  defineProps<{
    type: 'footer' | 'drawer';
  }>();

  const globalStore = useGlobalStore();
  const { layoutData, defaultLocaleLayoutData } = storeToRefs(globalStore);
  const { getContent } = useProjectMethods();
  const { openModal } = useModalStore();
  const layoutStore = useLayoutStore();
  const { isDrawerCompact } = storeToRefs(layoutStore);

  const allowInstall = ref(false);
  const appleNotCompatible = ref(false);
  const { isMobile } = storeToRefs(useDeviceStore());
  const bsInstallApp = ref<IBottomSheetComponent | null>(null);

  onMounted(() => {
    if (typeof window !== 'undefined') {
      if (window.navigator) {
        const userAgent = window.navigator.userAgent;
        const parsedUserAgent = UAParser(userAgent);

        appleNotCompatible.value = parsedUserAgent?.browser?.name === 'Safari' || parsedUserAgent?.os?.name === 'iOS';
      }

      if (window.pwa) {
        window.pwa.onInit(() => {
          allowInstall.value = !!window.pwa?.allowInstall;
        });
      }
    }
  });

  const installApp = (): void => {
    if (typeof window === 'undefined') return;

    if (appleNotCompatible || !allowInstall.value) {
      if (isMobile.value) {
        bsInstallApp.value?.open();
      } else {
        openModal(ModalName.INSTALL_APP);
      }

      return;
    }

    window.pwa?.install();
  };
</script>

<style src="~/assets/styles/components/atomic/menu/install-app.scss" lang="scss" />
